import { createContext } from "react";


export const mapContext = createContext();